import { TextFrameColorOption } from './ui-types';

export const DEFAULT_TEXT_FRAME_COLORS: TextFrameColorOption[] = [
    { hex: '#000000', name: 'Black' },
    { hex: '#FFFFFF', name: 'White' },
    { hex: '#404040', name: 'Dark Gray' },
    { hex: '#808080', name: 'Gray' },
    { hex: '#C0C0C0', name: 'Light Gray' },
    { hex: '#FF0000', name: 'Red' },
    { hex: '#FF4040', name: 'Coral Red' },
    { hex: '#FFC0CB', name: 'Pink' },
    { hex: '#FF00FF', name: 'Magenta' },
    { hex: '#800080', name: 'Purple' },
    { hex: '#7F00FF', name: 'Violet' },
    { hex: '#40E0D0', name: 'Turquoise' },
    { hex: '#ADD8E6', name: 'Light Blue' },
    { hex: '#0047AB', name: 'Cobalt Blue' },
    { hex: '#000080', name: 'Navy' },
    { hex: '#008000', name: 'Green' },
    { hex: '#7CFC00', name: 'Grass Green' },
    { hex: '#FFFF00', name: 'Yellow' },
    { hex: '#FFDAB9', name: 'Peach' },
    { hex: '#FFA500', name: 'Orange' },
];
